import React, {memo} from "react";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import PropTypes from "prop-types";
import Loader from "../../components/Loader";
import GroupForm from "../Forms/GroupForm";

const AddGroup = (props) => {
  const {data, onCancel, open} = props;

  return (
    <Modal unmountOnClose={true} isOpen={open} backdrop={"static"} size={"lg"}>
      <Loader />
      <ModalHeader>{data && data.id ? "Edit Group" : "Add Group"}</ModalHeader>
      <ModalBody>
        <div className="pl-lg-4">
          <GroupForm data={data} onCancel={onCancel} />
        </div>
      </ModalBody>
    </Modal>
  );
};

AddGroup.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  data: PropTypes.object,
};

export default memo(AddGroup);
